import { render, staticRenderFns } from "./CompanyInvestments.vue?vue&type=template&id=3b266562&scoped=true&"
import script from "./CompanyInvestments.vue?vue&type=script&lang=js&"
export * from "./CompanyInvestments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInvestments.vue?vue&type=style&index=0&id=3b266562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b266562",
  null
  
)

export default component.exports